import { getFormattedDate } from 'legacy/hpscoutso/components/pages/amsEligibilityPartnersSearch/components/restriction/components/restrictionTooltipContent/helpers/getFormattedDate'

import { IColumn } from 'core-components/library/list/types'
import { IAmsLATAMSearchResponse } from 'onboarding/classes/models/aplAmsLatam'
import { APLAMSTranslationCodes } from 'onboarding/configs/translations/aplAMSTranslationCodes'
import { ITranslationFunction } from 'onboarding/context/LanguageContext'

import styles from './getTableColumns.module.scss'

export const getTableColumns = (t: ITranslationFunction): IColumn<IAmsLATAMSearchResponse>[] => {
  return [
    {
      title: 'Date',
      field: 'reportDate',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'DBA',
      field: 'dba',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: t(APLAMSTranslationCodes.print_hw_column),
      field: 'printHW',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{hasCategory(item.printHW)}</div>
      },
    },
    {
      title: t(APLAMSTranslationCodes.supplies_column),
      field: 'supplies',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{hasCategory(item.supplies)}</div>
      },
    },
    {
      title: 'Large Format',
      field: 'largeFormat',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{hasCategory(item.largeFormat)}</div>
      },
    },
    {
      title: t(APLAMSTranslationCodes.tax_id_column),
      field: 'taxId',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: t(APLAMSTranslationCodes.restrictions_column),
      field: 'restrictions',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return tableRestrictions(item)
      },
    },
  ]
}

const tableRestrictions = (item: IAmsLATAMSearchResponse) => {
  if (!item.restrictions.length) {
    return <div>-</div>
  }

  return (
    <table className={styles.lightweightTable}>
      <thead>
        <tr>
          <th>Category</th>
          <th>PLs</th>
          <th>From</th>
          <th>To</th>
        </tr>
      </thead>
      {item.restrictions.map((restriction) => {
        let from = ''
        let to = ''
        try {
          from = getFormattedDate(new Date(restriction.startDate))
        } catch (e) {
          console.error(e)
        }

        try {
          to = getFormattedDate(new Date(restriction.endDate))
        } catch (e) {
          console.error(e)
        }

        return (
          <tr key={`${restriction.category}_${from}_${to}`}>
            <td>{restriction.category}</td>
            <td>{restriction.pl.join(', ')}</td>
            <td>{from}</td>
            <td>{to}</td>
          </tr>
        )
      })}
    </table>
  )
}

const hasCategory = (value: boolean | null) => {
  if (value == null) {
    return '-'
  }

  return value ? 'Y' : 'N'
}
